import * as React from 'react';
import * as R from 'ramda';
import { WithRouterProps } from 'react-router';

import ListingPreviewCardNext from 'ha/components/next/ListingCard';
import { ListingPreviewCard as ListingPreviewCardType } from 'ha/services/apiV2/types/AlgoliaListing';
import { formatDate } from 'ha/helpers/hadate';

export const EVENT_NAME = 'Search listing clicked';

interface Props {
  listingId: number;
  pageInfo: { offset: number; limit: number };
  cityCanonical: string;
  countryCode: string;
  filtersAnalytics: {
    listingIdResults: number[];
    numberOfOrganicListings: number;
    numberOfPartnerListings: number;
    numberOfSearchResults: number;
  };
  listingsAnalytics: {
    listingIdResults: number[];
  };
  listingProps: {
    room: ListingPreviewCardType;
    key: number;
    onMouseEnter?: (id: number) => void;
    onMouseLeave?: (id: number) => void;
    isLazy?: boolean;
    withGallery?: boolean;
    withFavorites?: boolean;
    isMapMarker?: boolean;
  };
  trackLocation?: string;
  track: (name: string, params: object) => void;
  isAdvertiserSearch: boolean;
}

export default class ListingPreviewCardTracked extends React.Component<
  Props & WithRouterProps
> {
  handleCardClick = () => {
    const {
      track,
      cityCanonical,
      countryCode,
      filtersAnalytics,
      pageInfo: { offset, limit },
      listingId,
      listingsAnalytics: { listingIdResults },
      isAdvertiserSearch,
      trackLocation,
    } = this.props;

    const params = {
      type: 'link',
      cityCanonical,
      countryCode,
      ...R.omit(
        [
          'listingIdResults',
          'numberOfOrganicListings',
          'numberOfPartnerListings',
          'numberOfSearchResults',
        ],
        filtersAnalytics,
      ),
      position: offset + listingIdResults.indexOf(listingId) + 1,
      page: Math.floor(offset / limit) + 1,
      pageType: isAdvertiserSearch ? 'advertiser-search' : 'search',
      location: trackLocation,
    };

    track(EVENT_NAME, params);
  };

  render() {
    const {
      location: {
        query: { startDate, endDate },
      },
    } = this.props;

    const queryParams = {
      startDate: startDate ? formatDate('en', 'YYYY-MM-DD', startDate) : null,
      endDate: endDate ? formatDate('en', 'YYYY-MM-DD', endDate) : null,
    };

    return (
      <ListingPreviewCardNext
        {...this.props.listingProps}
        queryParams={queryParams}
        onCardClick={this.handleCardClick}
      />
    );
  }
}
